import React from 'react'
import PropTypes, { arrayOf, shape } from 'prop-types'

import {
  TIERED_INTERVENTION_PROGRAM_LIST,
  K5_PROGRAM_TYPE,
} from 'utils/program/types'

import ShutterList from 'components/ShutterList'
import TieredInterventionCallout from 'components/TieredInterventionCallout'
import TieredInterventionsHeader from 'components/TieredInterventionsHeader'
import TieredInterventionUnitCard from 'components/TieredInterventionUnitCard'
import CoursePreviewBanner from 'components/CoursePreviewBanner'
import { resolveCurriculumPreviewMode } from 'utils/routing/routeHelpers'
import { PageWrapper } from 'components/ShutterList/component.styles'

import {
  StyledBackgroundImage,
  TieredInterventionShutterList,
  BannerSpacer,
  PreviewBannerWrapper,
} from './component.styles'
import { TIER_LABEL, SHUTTER_LIST_CLASS_NAME } from './constants'

const TieredInterventionsUnitsPageComponent = ({
  backLinkText,
  content,
  courseDisplayTitle,
  handleBackClick,
  handleHeaderTabChange,
  headerTabs,
  isPreview,
  items,
  location,
  match,
  programType = K5_PROGRAM_TYPE,
  progressText,
}) => {
  const { search } = location || {}
  const { url: currentUrl } = match || {}
  const queryParamsString = search || ''
  const { unitTi } = content || {}
  const {
    displayTitle: pageDisplayTitle,
    description: pageDescription,
    image: pageImage,
    courseSummary,
  } = unitTi || {}

  const courseDescription = courseSummary?.description
  const showPreviewBanner =
    isPreview || resolveCurriculumPreviewMode({ match, location })

  const hasFooter = !!pageImage

  const tabDescription = {
    body: pageDescription,
    title: pageDisplayTitle,
    hasFooter,
    footerChildren: hasFooter && <StyledBackgroundImage src={pageImage?.url} />,
  }

  const renderItem = item => (
    <TieredInterventionUnitCard
      description={item?.description}
      isPreviewMode={showPreviewBanner || Boolean(item?.isPreview)}
      markedComplete={showPreviewBanner ? false : item?.markedComplete}
      path={`${currentUrl}/${item?.path}${queryParamsString}`}
      programType={programType}
      tags={item?.tags}
      title={item?.title}
    />
  )

  return (
    <PageWrapper>
      {showPreviewBanner && (
        <PreviewBannerWrapper>
          <BannerSpacer />
          <CoursePreviewBanner />
        </PreviewBannerWrapper>
      )}
      <TieredInterventionsHeader
        backLinkOnClick={handleBackClick}
        backLinkText={backLinkText}
        description={courseDescription}
        onTabChange={handleHeaderTabChange}
        programType={programType}
        progressText={progressText}
        tabs={headerTabs}
        tierLabel={TIER_LABEL}
        title={courseDisplayTitle}
      />
      <TieredInterventionShutterList>
        <ShutterList
          className={SHUTTER_LIST_CLASS_NAME}
          contentDescription={tabDescription}
          items={items}
          renderContentDescription={contentDescription => (
            <TieredInterventionCallout
              contentDescription={contentDescription}
              programType={programType}
            />
          )}
          renderItem={renderItem}
        />
      </TieredInterventionShutterList>
    </PageWrapper>
  )
}

const summary = shape({
  description: PropTypes.string,
  isPreview: PropTypes.bool,
  markedComplete: PropTypes.bool,
  path: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
})

TieredInterventionsUnitsPageComponent.propTypes = {
  backLinkText: PropTypes.string,
  content: PropTypes.shape({
    unitTi: shape({
      displayTitle: PropTypes.string,
      description: PropTypes.string,
      image: shape({
        title: PropTypes.string,
        url: PropTypes.string,
      }),
      courseSummary: shape({
        description: PropTypes.string,
      }),
    }),
  }),
  courseDisplayTitle: PropTypes.string,
  handleBackClick: PropTypes.func,
  handleHeaderTabChange: PropTypes.func,
  headerTabs: PropTypes.array,
  isPreview: PropTypes.bool,
  items: arrayOf(summary),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  match: PropTypes.shape({
    url: PropTypes.string,
  }),
  programType: PropTypes.oneOf(TIERED_INTERVENTION_PROGRAM_LIST),
  progressText: PropTypes.string,
}

export { TieredInterventionsUnitsPageComponent }
